import React from 'react';
import { connect } from 'react-redux';

function formatPtbLastUpdated(date) {
  if (!date) {
    return '';
  }

  return date.toLocaleTimeString(undefined, {
    hour: 'numeric',
    minute: '2-digit',
  });
}

export function RefreshPtbButton({ lastPtbUpdate, onRefreshClick, style = {} }) {
  const handleRefreshClick = () => {
    onRefreshClick?.();
  };

  const lastUpdatedLabel = formatPtbLastUpdated(lastPtbUpdate);

  return (
    <div className="refresh-btn-container ptb-board-refresh" style={style}>
      <button
        onClick={handleRefreshClick}
        className="btn btn-utility"
        type="button"
      >
        Refresh
      </button>
      {lastUpdatedLabel ? (
        <span className="text ptb-board-refresh__last-updated">
          Last updated {lastUpdatedLabel}
        </span>
      ) : null}
    </div>
  );
}

const mapStateToProps = ({ ptb }) => ({
  lastPtbUpdate: ptb.lastPtbUpdate,
});

const RefreshBoardButton = connect(mapStateToProps)(RefreshPtbButton);

export default RefreshBoardButton;
